import Vue from 'vue';
import Router from 'vue-router';
import Meta from 'vue-meta'
Vue.use(Router);
Vue.use(Meta);


import Index from '../components/Index.vue'
//云对象
import NewDuixiang from '../components/yunduixiang/NewDuixiang.vue'
import DuixiangLists from '../components/yunduixiang/DuixiangLists.vue'
import NewDuixiangForm from '../components/yunduixiang/NewDuixiangForm.vue'
import TagsManage from '../components/yunduixiang/TagsManage.vue'
import GroupManage from '../components/yunduixiang/GroupManage.vue'
import Upload from '../components/yunduixiang/Upload.vue'
//公共模块
import Login from '../components/Login.vue'
import Register from '../components/Register.vue'
import Me from '../components/Me.vue'
//云检查
import Yunjiancha from '../components/yunjiancha/Yunjiancha.vue'
import JianchaSetting from '../components/yunjiancha/JianchaSetting.vue'
import NewJcdx from '../components/yunjiancha/NewJcdx.vue'
import NewJcry from '../components/yunjiancha/NewJcry.vue'
import NewItem from '../components/yunjiancha/NewItem.vue'
import ItemSetting from '../components/yunjiancha/ItemSetting.vue'
import JianchaFabu from '../components/yunjiancha/JianchaFabu.vue'
import JianchaAction from '../components/yunjiancha/JianchaAction.vue'
import Action from '../components/yunjiancha/Action.vue'
import JianchaTongji from '../components/yunjiancha/JianchaTongji.vue'

export default new Router({
  //mode:'history',
  routes: [
    {
      path: '/', 
      component:Index
    },
    //云对象
    {
      path: '/newduixiang', 
      component:NewDuixiang
    },
    {
      name: 'duixianglists',
      path: '/duixianglists/:group_id', 
      component:DuixiangLists
    }, 
    {
      name:'new_by_form',
      path:'/newduixiang/:group_id/by_form',
      component:NewDuixiangForm
    },
    {
      name: 'tags_manage',
      path:'/newduixiang/:group_id/tags_manage',
      component:TagsManage
    },
    {
      name: 'group_manage',
      path:'/newduixiang/:group_id/group_manage',
      component:GroupManage
    },
    {
      name: 'upload',
      path:'/newduixiang/:group_id/upload',
      component:Upload
    },
    //公共
    {
      name: 'login',
      path:'/login',
      component:Login
    },
    {
      name: 'register',
      path:'/register',
      component:Register
    },
    {
      name: 'me',
      path:'/me',
      component:Me
    },
    //云检查
    {
      name: 'yunjiancha',
      path:'/yunjiancha',
      component:Yunjiancha
    },
    
    {
      name: 'newjcdx',
      path: '/newjcdx/:app_id', 
      component:NewJcdx
    }, 
    {
      name: 'newjcry',
      path: '/newjcry/:app_id', 
      component:NewJcry
    },
    {
      name: 'newitem',
      path: '/newitem/:app_id', 
      component:NewItem
    }, 
    {
      name: 'jianchasetting',
      path: '/jianchasetting/:app_id', 
      component:JianchaSetting
    }, 
    {
      name: 'itemsetting',
      path: '/itemsetting/:app_id', 
      component:ItemSetting
    }, 
    {
      name: 'jianchafabu',
      path: '/jianchafabu/:app_id', 
      component:JianchaFabu
    }, 
    
    {
      name: 'jianchaaction',
      path: '/jianchaaction/:app_id', 
      component:JianchaAction,
    }, 
    {
      name: 'jianchatognji',
      path: '/jianchatognji/:app_id', 
      component:JianchaTongji
    }, 
    {
      name: 'action',
      path: '/action/:app_id', 
      props: (route) => ({ query: route.query.jcdx_id}),
      component:Action

    }, 
  ]
})
